export default "__VITE_ASSET__60cfe40d__"